import RoleDetail from '../components/Detail'
import useModalForm from '../../../@hooks/useModalForm'
import Service from '../../../@services/role'

export default function useModifierRoleDialog() {
  const { open } = useModalForm(RoleDetail)

  const openDialog = id => {
    return open(
      undefined,
      async () => {
        const res = (await Service.getRoleDetail(id)) || {}
        console.log({ res })
        return {
          id: res.id,
          name: res.name,
          permissions: res.permissions || [],
          description: res.description,
        }
      },
      {
        title: '角色详情',
      }
    )
  }

  return openDialog
}
